module.exports = __webpack_public_path__ + "static/media/Logo.40b25651.png";